module.exports = __webpack_public_path__ + "static/media/angarachickentikka.e91ac05e.jpg";